import { FC } from 'react';
import {
    StyledCheckboxAndPriceWrapper,
    StyledDisclaimerWrapper,
    StyledInstallationCheckboxLabel,
    StyledInstallationCheckboxWrapper,
    StyledInstallationDisclaimer,
    StyledInstallationPrice,
    StyledQuantityPicker,
} from './product-installation-checkbox.styled';
import { CheckBox } from '../../shared';
import { getShopPrice } from '../../../utils/helpers';
import { InstallationRequirement } from '../../../lib/api/models/shop';

type IProps = {
    installationRequirement: InstallationRequirement;
    installationPrice: number | null;
    installationQuantity?: number | null;
    installationQuantityOptions?: { value: string; displayValue: string }[];
    productQuantity?: number | null;
    productId: string;
    selected: boolean;
    isRequired?: boolean;
    setSelected: (selected: boolean) => void;
    onChangeInstallationQuantity?: (quantity: number) => void;
};

export const ProductInstallationCheckbox: FC<IProps> = ({
    installationRequirement,
    productId,
    installationPrice,
    installationQuantity,
    selected,
    installationQuantityOptions,
    productQuantity,
    isRequired = false,
    setSelected,
    onChangeInstallationQuantity,
}) => {
    if (installationPrice === null && installationRequirement === 'Valgfri montering') return null;
    return (
        <>
            <StyledInstallationCheckboxWrapper>
                <StyledCheckboxAndPriceWrapper>
                    <CheckBox
                        id={productId}
                        checked={selected}
                        disabled={installationRequirement === 'Obligatorisk montering hos Hessel'}
                        onChange={(e) => setSelected(e)}
                        value="installation"
                    >
                        <StyledInstallationCheckboxLabel>
                            {isRequired ? 'Obligatorisk montering' : 'Tilføj montering'}
                        </StyledInstallationCheckboxLabel>
                    </CheckBox>
                    {installationQuantity !== null && installationQuantity !== undefined && (productQuantity ? productQuantity > 1 : true) && (
                        <StyledQuantityPicker
                            canValidateInputField={false}
                            id={productId}
                            isValid={true}
                            label={'Antal'}
                            onChange={(value) => {
                                onChangeInstallationQuantity?.(Number(value?.value));
                            }}
                            options={installationQuantityOptions ?? []}
                            value={{
                                value: installationQuantity?.toString(),
                                displayValue: installationQuantity?.toString(),
                            }}
                        ></StyledQuantityPicker>
                    )}
                    <StyledInstallationPrice>
                        {installationRequirement === 'Obligatorisk montering hos Hessel'
                            ? 'Inkl. i prisen'
                            : `+${getShopPrice(installationPrice ?? 0)}`}
                    </StyledInstallationPrice>
                </StyledCheckboxAndPriceWrapper>
                <StyledDisclaimerWrapper>
                    <StyledInstallationDisclaimer>Dato og tidspunkt vælges i checkout</StyledInstallationDisclaimer>
                </StyledDisclaimerWrapper>
            </StyledInstallationCheckboxWrapper>
        </>
    );
};
